import styled from "styled-components";
import { _, dayjs } from "@sablier/v2-mixins";
import Calendar from "antd/lib/calendar";
import type { ComponentProps } from "react";

const Wrapper = styled.div`
  flex: 1;
  height: 100%;
  & > * {
    width: 100%;
  }
  .ant-picker-calendar {
    border: 2px solid ${(props) => props.theme.colors.border};
    border-radius: 6px;
    background-color: ${(props) => props.theme.colors.dark150};
    .ant-picker-panel {
      background-color: ${(props) => props.theme.colors.dark150};

      thead {
        border-bottom: 2px solid ${(props) => props.theme.colors.border};
      }
      .ant-picker-body {
        padding-top: 0;
      }

      .ant-picker-cell,
      th {
        ${(props) => props.theme.styles.textParagraphMini}
        & {
          height: 42px;
          color: ${(props) => props.theme.colors.dark1000};
          font-weight: 600;
        }
      }

      .ant-picker-calendar-date-value {
        ${(props) => props.theme.styles.row}
        & {
          justify-content: center;
          height: 100%;
        }
      }

      .ant-picker-cell-in-view {
        color: ${(props) => props.theme.colors.gray100};
        .ant-picker-cell-inner {
          width: 28px;
          height: 28px;
        }

        &.ant-picker-cell-selected .ant-picker-cell-inner {
          border-radius: 4px;
          background: ${(props) =>
            props.theme.colors.secondaryMiddle} !important;
        }
        &:not(.ant-picker-cell-selected) {
          &:hover .ant-picker-calendar-date-value {
            border-radius: 4px;
            background-color: ${(props) => props.theme.colors.dark400};
          }
        }
      }
    }

    .ant-picker-calendar-header {
      .ant-radio-group {
        display: none;
      }

      .ant-select {
        ${(props) => props.theme.styles.row}
        & {
          span:not(.ant-select-arrow) {
            ${(props) => props.theme.styles.textParagraphMini}
            & {
              color: ${(props) => props.theme.colors.white};
            }
          }

          .ant-select-arrow {
            .anticon {
              ${(props) => props.theme.styles.row}
              & {
                align-items: center;
              }
            }
          }
          .ant-select-selector {
            height: auto;
            padding: 2px 12px;
            border: 2px solid ${(props) => props.theme.colors.border};
            border-radius: 4px;
            background-color: ${(props) => props.theme.colors.dark400};
          }
        }
      }

      .ant-select-dropdown {
        border: 2px solid ${(props) => props.theme.colors.border};
        border-radius: 6px;
        background-color: ${(props) => props.theme.colors.dark150};

        .ant-select-item {
          ${(props) => props.theme.styles.textParagraphMini}
          & {
            padding-top: 8px;
            padding-bottom: 8px;
            color: ${(props) => props.theme.colors.gray100};
            font-weight: 600;
          }

          &.ant-select-item-option-selected {
            ${(props) => props.theme.styles.row}
            & {
              justify-content: center;
              color: ${(props) => props.theme.colors.white};
              background-color: ${(props) =>
                props.theme.colors.secondaryMiddle};
            }
          }
        }
      }
    }
  }

  ${(props) => props.theme.medias.maxMD} {
    .ant-picker-calendar {
      .ant-picker-calendar-header {
        display: flex;
      }
    }
  }

  ${(props) => props.theme.medias.maxXXS} {
    width: calc(100vw - 12px);
    margin-left: -12px;
  }
`;

const range: [dayjs.Dayjs, dayjs.Dayjs] = [
  dayjs(new Date(2010, 1, 1)),
  dayjs(new Date(2100, 1, 1)),
];
interface Props {
  value: ComponentProps<typeof Calendar>["value"];
  onChange: (value: string) => void;
}

function Element({ value, onChange }: Props) {
  return (
    <Wrapper>
      <Calendar
        fullscreen={false}
        value={value}
        onChange={(value) => onChange(value.valueOf().toString())}
        validRange={range}
      />
    </Wrapper>
  );
}

export default Element;
